import type { GetServerSidePropsContext } from 'next'

export function getStoreURL(
  storeURLFull: string | undefined,
  overrideURLFull: string | false | undefined,
  path: string,
  params?: URLSearchParams,
  useOrigin?: boolean,
) {
  if (!storeURLFull) {
    return path + (params ? `?${params.toString()}` : '')
  }

  const urlFull = overrideURLFull || storeURLFull
  const url = new URL(path, useOrigin ? new URL(urlFull).origin : urlFull)

  if (params) {
    params.forEach((value, key) => {
      url.searchParams.set(key, value)
    })
  }

  return url.toString()
}

export function getStoreURLByContext(context: GetServerSidePropsContext, path: string, params?: URLSearchParams, useOrigin?: boolean) {
  return getStoreURL(context.req.thStore.config?.urlFull, context.req.thOverrideStoreURLFull, path, params, useOrigin)
}
